module.exports = __webpack_public_path__ + "static/media/40.85e4ca36.png";